import { render, staticRenderFns } from "./vlinput.vue?vue&type=template&id=bcc99252&scoped=true"
import script from "./vlinput.vue?vue&type=script&lang=js"
export * from "./vlinput.vue?vue&type=script&lang=js"
import style0 from "./vlinput.vue?vue&type=style&index=0&id=bcc99252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc99252",
  null
  
)

export default component.exports